export enum EFieldType {
	TABLE = 'TABLE',
	TOOLTIP = 'TOOLTIP',
	DROPDOWN = 'DROPDOWN',
	GROUP = 'GROUP',
	FILE = 'FILE',
	CHECKBOX = 'CHECKBOX',
	SWITCH_WITH_LABEL = 'SWITCH_WITH_LABEL',
	DIVIDER = 'DIVIDER',
	tel = 'tel',
	number = 'number',
	email = 'email',
	text = 'text',
	amount = 'amount',
	HIDDEN = 'HIDDEN',
	TEXT_WITHOUT_BG = 'TEXT_WITHOUT_BG',
	TABS = 'TABS',
}

export enum EFieldValueTransform {
	UPPERCASE = 'UPPERCASE',
	LOWERCASE = 'LOWERCASE',
	UPPERCASE_FIRST = 'UPPERCASE_FIRST',
}

export enum EContragentType {
	INTERNAL = 'INTERNAL',
	FOREIGN = 'FOREIGN'
}

export type FieldModelByKey = {
	[P in EFieldType]: () => any
}